import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as crypto from 'crypto-js';


@Injectable()
export class APIEncryptionDecryption {

    constructor(       

    ) { }


    public encrypt_mobile(mobile): Observable<any> {

        var salt = crypto.lib.WordArray.random(128 / 8);
        var key = crypto.PBKDF2("123", salt, {
            256: 256 / 32,
            100: 100
        });
        var iv = crypto.lib.WordArray.random(128 / 8);
        var encrypted = crypto.AES.encrypt(mobile, key, {  // instead of message try some string or  “9876543210”
            iv: iv,
            padding: crypto.pad.Pkcs7,
            mode: crypto.mode.CBC
        });
        var encrypted_mob = salt.toString() + iv.toString() + encrypted.toString();
        console.log("encrypted : ", encrypted_mob);
        return encrypted_mob;
    }


    public decrypt_mobile(encrypted_mob): Observable<any> {
console.log("encrypted mobile to be decrypted : ",encrypted_mob)
        var salt = crypto.enc.Hex.parse(encrypted_mob.substr(0, 32));
        var iv = crypto.enc.Hex.parse(encrypted_mob.substr(32, 32))
        var encrypted = encrypted_mob.substring(64);
        var key = crypto.PBKDF2("123", salt, {
            256: 256 / 32,
            100: 100
        });
        var decrypted = crypto.AES.decrypt(encrypted, key, {
            iv: iv,
            padding: crypto.pad.Pkcs7,
            mode: crypto.mode.CBC
        });

        var decrypted_mob = decrypted.toString(crypto.enc.Utf8);
        console.log("decryted : ", decrypted_mob);
        return decrypted_mob;
    }


}
